<template>
  <div class="app-gallery-grid-loader">
    <div class="app-gallery-grid-loader__title sm-item-primary"></div>
    <div class="app-gallery-grid-loader__items">
      <div class="app-gallery-grid-loader__item" v-for="index in 9" :key="index">
          <div class="app-gallery-grid-loader__item-image sm-item-primary"></div>
          <div class="app-gallery-grid-loader__item-name sm-item-secondary"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppGalleryGridLoader',
};
</script>

<style lang="scss" scoped>
@import "app-gallery-grid-loader";
</style>
